class Connection {
  constructor() {
    this.arrivalStation = ''
    this.departureStation = ''
    this.arrivalStationName = ''
    this.departureStationName = ''
    this.departureDate = ''
    this.departureTime = ''
    this.trainNo = ''
    this.ticketNo = ''
    this.delay = null
    this.isSelected = false
  }
}

export { Connection }
